// extracted by mini-css-extract-plugin
module.exports = {"NavigationLinks":"NavigationLinks_NavigationLinks__25t94"};